import './assets/index-Au1Gr_G6.css';
import w from "@nextcloud/vue/dist/Components/NcAvatar.js";
import O from "@nextcloud/vue/dist/Components/NcSelect.js";
import T from "lodash-es/debounce.js";
import S from "@nextcloud/vue/dist/Components/NcActions.js";
import k from "@nextcloud/vue/dist/Components/NcActionButton.js";
import A, { set as f } from "vue";
import $ from "@nextcloud/axios";
import { generateOcsUrl as d } from "@nextcloud/router";
/*
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class D {
  constructor() {
    this.http = $;
  }
  listCollection(e) {
    return this.http.get(d("collaboration/resources/collections/{collectionId}", { collectionId: e }));
  }
  renameCollection(e, o) {
    return this.http.put(d("collaboration/resources/collections/{collectionId}", { collectionId: e }), {
      collectionName: o
    }).then((n) => n.data.ocs.data);
  }
  getCollectionsByResource(e, o) {
    return this.http.get(d("collaboration/resources/{resourceType}/{resourceId}", { resourceType: e, resourceId: o })).then((n) => n.data.ocs.data);
  }
  createCollection(e, o, n) {
    return this.http.post(d("collaboration/resources/{resourceType}/{resourceId}", { resourceType: e, resourceId: o }), {
      name: n
    }).then((r) => r.data.ocs.data);
  }
  addResource(e, o, n) {
    return n = "" + n, this.http.post(d("collaboration/resources/collections/{collectionId}", { collectionId: e }), {
      resourceType: o,
      resourceId: n
    }).then((r) => r.data.ocs.data);
  }
  removeResource(e, o, n) {
    return this.http.delete(d("collaboration/resources/collections/{collectionId}", { collectionId: e }), { params: { resourceType: o, resourceId: n } }).then((r) => r.data.ocs.data);
  }
  search(e) {
    return this.http.get(d("collaboration/resources/collections/search/{query}", { query: e })).then((o) => o.data.ocs.data);
  }
}
const p = new D();
/*
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const u = A.observable({
  collections: []
}), h = {
  addCollections(s) {
    f(u, "collections", s);
  },
  addCollection(s) {
    u.collections.push(s);
  },
  removeCollection(s) {
    f(u, "collections", u.collections.filter((e) => e.id !== s));
  },
  updateCollection(s) {
    const e = u.collections.findIndex((o) => o.id === s.id);
    e !== -1 ? f(u.collections, e, s) : u.collections.push(s);
  }
}, l = {
  fetchCollectionsByResource({ resourceType: s, resourceId: e }) {
    return p.getCollectionsByResource(s, e).then((o) => (h.addCollections(o), o));
  },
  createCollection({ baseResourceType: s, baseResourceId: e, resourceType: o, resourceId: n, name: r }) {
    return p.createCollection(s, e, r).then((m) => {
      h.addCollection(m), l.addResourceToCollection({
        collectionId: m.id,
        resourceType: o,
        resourceId: n
      });
    });
  },
  renameCollection({ collectionId: s, name: e }) {
    return p.renameCollection(s, e).then((o) => (h.updateCollection(o), o));
  },
  addResourceToCollection({ collectionId: s, resourceType: e, resourceId: o }) {
    return p.addResource(s, e, o).then((n) => (h.updateCollection(n), n));
  },
  removeResource({ collectionId: s, resourceType: e, resourceId: o }) {
    return p.removeResource(s, e, o).then((n) => {
      n.resources.length > 0 ? h.updateCollection(n) : h.removeCollection(n);
    });
  },
  search(s) {
    return p.search(s);
  }
};
function R(s, e, o, n, r, m, _, I) {
  var i = typeof s == "function" ? s.options : s;
  e && (i.render = e, i.staticRenderFns = o, i._compiled = !0), n && (i.functional = !0), m && (i._scopeId = "data-v-" + m);
  var a;
  if (_ ? (a = function(c) {
    c = c || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !c && typeof __VUE_SSR_CONTEXT__ < "u" && (c = __VUE_SSR_CONTEXT__), r && r.call(this, c), c && c._registeredComponents && c._registeredComponents.add(_);
  }, i._ssrRegister = a) : r && (a = I ? function() {
    r.call(
      this,
      (i.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : r), a)
    if (i.functional) {
      i._injectStyles = a;
      var b = i.render;
      i.render = function(N, v) {
        return a.call(v), b(N, v);
      };
    } else {
      var C = i.beforeCreate;
      i.beforeCreate = C ? [].concat(C, a) : [a];
    }
  return {
    exports: s,
    options: i
  };
}
const B = {
  name: "CollectionListItem",
  components: {
    NcAvatar: w,
    NcActions: S,
    NcActionButton: k
  },
  props: {
    collection: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      detailsOpen: !1,
      newName: null,
      error: {}
    };
  },
  computed: {
    getIcon() {
      return (s) => [s.iconClass];
    },
    typeClass() {
      return (s) => "resource-type-" + s.type;
    },
    limitedResources() {
      return (s) => s.resources ? s.resources.slice(0, 2) : [];
    },
    iconUrl() {
      return (s) => s.mimetype ? OC.MimeType.getIconUrl(s.mimetype) : s.iconUrl ? s.iconUrl : "";
    }
  },
  methods: {
    toggleDetails() {
      this.detailsOpen = !this.detailsOpen;
    },
    showDetails() {
      this.detailsOpen = !0;
    },
    hideDetails() {
      this.detailsOpen = !1;
    },
    removeResource(s, e) {
      l.removeResource({
        collectionId: s.id,
        resourceType: e.type,
        resourceId: e.id
      });
    },
    openRename() {
      this.newName = this.collection.name;
    },
    renameCollection() {
      if (this.newName === "") {
        this.newName = null;
        return;
      }
      l.renameCollection({
        collectionId: this.collection.id,
        name: this.newName
      }).then((s) => {
        this.newName = null;
      }).catch((s) => {
        this.$set(this.error, "rename", t("core", "Failed to rename the project")), console.error(s), setTimeout(() => {
          f(this.error, "rename", null);
        }, 3e3);
      });
    }
  }
};
var E = function() {
  var e = this, o = e._self._c;
  return o("li", { staticClass: "collection-list-item" }, [o("NcAvatar", { staticClass: "collection-avatar", attrs: { "display-name": e.collection.name, "allow-placeholder": "" } }), e.newName === null ? o("span", { staticClass: "collection-item-name", attrs: { title: "" }, on: { click: e.showDetails } }, [e._v(e._s(e.collection.name))]) : o("form", { class: { shouldshake: e.error.rename }, on: { submit: function(n) {
    return n.preventDefault(), e.renameCollection.apply(null, arguments);
  } } }, [o("input", { directives: [{ name: "model", rawName: "v-model", value: e.newName, expression: "newName" }], attrs: { type: "text", autocomplete: "off", autocapitalize: "off" }, domProps: { value: e.newName }, on: { input: function(n) {
    n.target.composing || (e.newName = n.target.value);
  } } }), o("input", { staticClass: "icon-confirm", attrs: { type: "submit", value: "" } })]), !e.detailsOpen && e.newName === null ? o("div", { staticClass: "linked-icons" }, e._l(e.limitedResources(e.collection), function(n) {
    return o("a", { key: n.type + "|" + n.id, class: e.typeClass(n), attrs: { title: n.name, href: n.link } }, [o("img", { attrs: { src: e.iconUrl(n) } })]);
  }), 0) : e._e(), e.newName === null ? o("span", { staticClass: "sharingOptionsGroup" }, [o("NcActions", [o("NcActionButton", { attrs: { icon: "icon-info" }, on: { click: function(n) {
    return n.preventDefault(), e.toggleDetails.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.detailsOpen ? e.t("core", "Hide details") : e.t("core", "Show details")) + " ")]), o("NcActionButton", { attrs: { icon: "icon-rename" }, on: { click: function(n) {
    return n.preventDefault(), e.openRename.apply(null, arguments);
  } } }, [e._v(" " + e._s(e.t("core", "Rename project")) + " ")])], 1)], 1) : e._e(), o("transition", { attrs: { name: "fade" } }, [e.error.rename ? o("div", { staticClass: "error" }, [e._v(" " + e._s(e.error.rename) + " ")]) : e._e()]), o("transition", { attrs: { name: "fade" } }, [e.detailsOpen ? o("ul", { staticClass: "resource-list-details" }, e._l(e.collection.resources, function(n) {
    return o("li", { key: n.type + "|" + n.id, class: e.typeClass(n) }, [o("a", { attrs: { href: n.link } }, [o("img", { attrs: { src: e.iconUrl(n) } }), o("span", { staticClass: "resource-name" }, [e._v(e._s(n.name || ""))])]), o("span", { staticClass: "icon-close", on: { click: function(r) {
      return e.removeResource(e.collection, n);
    } } })]);
  }), 0) : e._e()])], 1);
}, L = [], U = /* @__PURE__ */ R(
  B,
  E,
  L,
  !1,
  null,
  "8e58e0a5",
  null,
  null
);
const j = U.exports, y = 0, g = 1, F = T(
  function(s, e) {
    s !== "" && (e(!0), l.search(s).then((o) => {
      this.searchCollections = o;
    }).catch((o) => {
      console.error("Failed to search for collections", o);
    }).finally(() => {
      e(!1);
    }));
  },
  500,
  {}
), P = {
  name: "CollectionList",
  components: {
    CollectionListItem: j,
    NcAvatar: w,
    NcSelect: O
  },
  props: {
    /**
     * Resource type identifier
     */
    type: {
      type: String,
      default: null
    },
    /**
     * Unique id of the resource
     */
    id: {
      type: String,
      default: null
    },
    /**
     * Name of the resource
     */
    name: {
      type: String,
      default: ""
    },
    isActive: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      selectIsOpen: !1,
      generatingCodes: !1,
      codes: void 0,
      value: null,
      model: {},
      searchCollections: [],
      error: null,
      state: u,
      isSelectOpen: !1
    };
  },
  computed: {
    collections() {
      return this.state.collections.filter((s) => typeof s.resources.find((e) => e && e.id === "" + this.id && e.type === this.type) < "u");
    },
    placeholder() {
      return this.isSelectOpen ? t("core", "Type to search for existing projects") : t("core", "Add to a project");
    },
    options() {
      const s = [];
      window.OCP.Collaboration.getTypes().sort().forEach((e) => {
        s.push({
          method: y,
          type: e,
          title: window.OCP.Collaboration.getLabel(e),
          class: window.OCP.Collaboration.getIcon(e),
          action: () => window.OCP.Collaboration.trigger(e)
        });
      });
      for (const e in this.searchCollections)
        this.collections.findIndex((o) => o.id === this.searchCollections[e].id) === -1 && s.push({
          method: g,
          title: this.searchCollections[e].name,
          collectionId: this.searchCollections[e].id
        });
      return s;
    }
  },
  watch: {
    type() {
      this.isActive && l.fetchCollectionsByResource({
        resourceType: this.type,
        resourceId: this.id
      });
    },
    id() {
      this.isActive && l.fetchCollectionsByResource({
        resourceType: this.type,
        resourceId: this.id
      });
    },
    isActive(s) {
      s && l.fetchCollectionsByResource({
        resourceType: this.type,
        resourceId: this.id
      });
    }
  },
  mounted() {
    l.fetchCollectionsByResource({
      resourceType: this.type,
      resourceId: this.id
    });
  },
  methods: {
    select(s, e) {
      s.method === y && s.action().then((o) => {
        l.createCollection({
          baseResourceType: this.type,
          baseResourceId: this.id,
          resourceType: s.type,
          resourceId: o,
          name: this.name
        }).catch((n) => {
          this.setError(t("core", "Failed to create a project"), n);
        });
      }).catch((o) => {
        console.error("No resource selected", o);
      }), s.method === g && l.addResourceToCollection({
        collectionId: s.collectionId,
        resourceType: this.type,
        resourceId: this.id
      }).catch((o) => {
        this.setError(t("core", "Failed to add the item to the project"), o);
      });
    },
    search(s, e) {
      F.bind(this)(s, e);
    },
    showSelect() {
      this.selectIsOpen = !0, this.$refs.select.$el.focus();
    },
    hideSelect() {
      this.selectIsOpen = !1;
    },
    isVueComponent(s) {
      return s._isVue;
    },
    setError(s, e) {
      console.error(s, e), this.error = s, setTimeout(() => {
        this.error = null;
      }, 5e3);
    }
  }
};
var V = function() {
  var e = this, o = e._self._c;
  return e.collections && e.type && e.id ? o("ul", { staticClass: "collection-list", attrs: { id: "collection-list" } }, [o("li", { on: { click: e.showSelect } }, [e._m(0), o("div", { attrs: { id: "collection-select-container" } }, [o("NcSelect", { ref: "select", attrs: { "aria-label-combobox": e.t("core", "Add to a project"), options: e.options, placeholder: e.placeholder, label: "title", limit: 5 }, on: { close: function(n) {
    e.isSelectOpen = !1;
  }, open: function(n) {
    e.isSelectOpen = !0;
  }, "option:selected": e.select, search: e.search }, scopedSlots: e._u([{ key: "selected-option", fn: function(n) {
    return [o("span", { staticClass: "option__desc" }, [o("span", { staticClass: "option__title" }, [e._v(e._s(n.title))])])];
  } }, { key: "option", fn: function(n) {
    return [o("span", { staticClass: "option__wrapper" }, [n.class ? o("span", { staticClass: "avatar", class: n.class }) : n.method !== 2 ? o("NcAvatar", { attrs: { "allow-placeholder": "", "display-name": n.title } }) : e._e(), o("span", { staticClass: "option__title" }, [e._v(e._s(n.title))])], 1)];
  } }], null, !1, 2397208459), model: { value: e.value, callback: function(n) {
    e.value = n;
  }, expression: "value" } }, [o("p", { staticClass: "hint" }, [e._v(" " + e._s(e.t("core", "Connect items to a project to make them easier to find")) + " ")])])], 1)]), o("transition", { attrs: { name: "fade" } }, [e.error ? o("li", { staticClass: "error" }, [e._v(" " + e._s(e.error) + " ")]) : e._e()]), e._l(e.collections, function(n) {
    return o("CollectionListItem", { key: n.id, attrs: { collection: n } });
  })], 2) : e._e();
}, x = [function() {
  var s = this, e = s._self._c;
  return e("div", { staticClass: "avatar" }, [e("span", { staticClass: "icon-projects" })]);
}], H = /* @__PURE__ */ R(
  P,
  V,
  x,
  !1,
  null,
  "75a4370b",
  null,
  null
);
const Q = H.exports;
export {
  Q as CollectionList,
  j as CollectionListItem
};
